<template>
  <div>
    <div class="card mb-2">
      <div class="card-header bg-primary text-white font-weight-bold">
        My Open Services
      </div>
      <LoadingSpinner v-if="userOpenServicesLoading" message="" size='1x' />
      <p v-else-if="userOpenServices.length === 0">
        You are not a Staff Lead of any Open Services
      </p>
      <div v-else>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">
                <span class='search-result-header'>Service ID</span>
              </th>
              <th scope="col">
                <span class='search-result-header'>Service Component(s)</span>
              </th>
              <th scope="col">
                <span class='search-result-header'>Project ID</span>
              </th>
              <th scope="col">
                <span class='search-result-header'>Open Date</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="service in visibleServices"
                :key="service.id"
                class="list-table-text">
                <td>
                  <router-link
                    :to="{ name: 'projectService', params: {
                    project_id: service.primaryProjectId,
                    id: service.id }}"
                    class="view-link"
                  >
                    {{ service.id + ' - ' + getCategoryName(service.categoryId)}} {{service.isMultiProperty ? ' (MP)' : '' }}
                  </router-link>
                </td>
                <td>
                  {{ componentsString(service) }}
                </td>
                <td :id="'service-proj' + service.id">
                  {{ service.primaryProjectId }}
                    <b-tooltip :target="'service-proj' + service.id">
                      {{service.projectName === null ? 'N/A' : service.projectName}}
                    </b-Tooltip>
                </td>
                <td>
                  {{ service.openDate | dateString }}
                </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <PaginationControls
      :orderedEntities="userOpenServices"
      :initialPageSize="initialPageSize"
      :pageSize="pageSize"
      :pageSizeOptions="pageSizeOptions"
      :currentPage="currentPage"
      :firstVisibleEntry="firstVisibleEntry"
      :lastVisibleEntry="lastVisibleEntry"
      :rows="rows"
      @update-current-page="updateCurrentPage"
      @update-page-size="updatePageSize">
    </PaginationControls>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
import { LookupModules } from '@/store/moduleConfig';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import Pagination from '@/mixins/Pagination';
import PaginationControls from '../common/PaginationControls.vue';

export default {
  name: 'MyServices',
  components: {
    LoadingSpinner,
    PaginationControls,
  },
  data() {
    return {
      pageSize: 100,
      currentPage: 1,
    };
  },
  mixins: [Pagination],
  mounted() {
    // dispatch actions to populate vuex state for this page
    this.$store.dispatch(`${LookupModules.SERVICE_CATEGORIES.namespace}/fetchOptions`,
      LookupModules.SERVICE_CATEGORIES.url);
    this.$store.dispatch(`${LookupModules.SERVICE_TYPES.namespace}/fetchOptions`,
      LookupModules.SERVICE_TYPES.url);
  },
  computed: {
    ...mapState('Service', {
      userOpenServices: state => state.userStaffLeadServices,
      userOpenServicesLoading: state => state.userStaffLeadServicesLoading,
    }),
    ...mapGetters(LookupModules.SERVICE_CATEGORIES.namespace, {
      getCategoryName: 'getName',
    }),
    ...mapGetters(LookupModules.SERVICE_TYPES.namespace, {
      getServiceTypeName: 'getName',
    }),
    rows() {
      return this.userOpenServices.length;
    },
    visibleServices() {
      // sort descending by openDate and ascending by serviceId
      return this.userOpenServices
        .slice(0)
        .sort((a, b) => moment(a.openDate).format('YYYYMMDD')
          - moment(b.openDate).format('YYYYMMDD')
          || a.id - b.id)
        .slice(
          ((this.currentPage - 1) * this.pageSize),
          (this.currentPage * this.pageSize),
        );
    },
  },
  methods: {
    componentsString(entity) {
      if (entity && entity.typeIds) {
        const typeIdsCopy = [...entity.typeIds];
        return typeIdsCopy
          .sort()
          .map(pi => this.getServiceTypeName(pi))
          .join('; ');
      }
      return null;
    },
  },
};
</script>
